export default __webpack_public_path__ + "static/item_09-bf3592a0a7afb458ab17ad9d5afe560b.jpg";